import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Scrollbar, Navigation, Pagination, Autoplay } from "swiper";
import BlogCard from "../components/common/BlogCard";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Blogs = (props) => {
  return (
    <div className="px-4 md:px-6 lg:px-8 xl:px-10 py-5">
      <Swiper
        freeMode={true}
        grabCursor={true}
        breakpoints={{
          1920: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          1285: {
            slidesPerView: 4,
            spaceBetween: 25,
          },
          980: {
            slidesPerView: 3.5,
            spaceBetween: 25,
          },
          640: {
            slidesPerView: 2.2,
            spaceBetween: 25,
          },
          350: {
            slidesPerView: 1.1,
            spaceBetween: 15,
          },
          200: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        }}
        modules={[Scrollbar, Navigation, Pagination, Autoplay]}
      >
        {props.blogs?.slice(0, 6).map((card) => (
          <SwiperSlide key={card._id}>
            <BlogCard card={card} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default Blogs;
